module.exports = __webpack_public_path__ + "static/img/Math.e582912.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Math.png
// module id = 2240
// module chunks = 61